import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_COUNTRY, DEFAULT_LOCALE } from '../constants';
const initialState = {
  // User data
  user: null,
  isAuthenticated: false,
  // Homepage content
  homeContent: null,
  homeContentLoading: false,
  homeContentError: null,
  homePlatformsList: null,
  homePlatformsListLoading: false,
  homePlatformsListError: null,
  // App state
  currentApp: 'home-app',
  isLoading: false,
  error: null,
  // Country selection
  selectedCountry: DEFAULT_COUNTRY,
  selectedLocale: DEFAULT_LOCALE,
  activeTab: '',
  // Default platform selection
  selectedPlatform: null,
  gaClientId: null,
  // Mobile search bar open state (shared across packages)
  isMobileSearchOpen: false
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // User actions
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setGaClientId: (state, action) => {
      state.gaClientId = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    // Home content actions
    setHomeContentLoading: (state, action) => {
      state.homeContentLoading = action.payload;
      if (action.payload) {
        state.homeContentError = null;
      }
    },
    setHomeContent: (state, action) => {
      state.homeContent = action.payload;
      state.homeContentLoading = false;
      state.homeContentError = null;
    },
    setHomeContentError: (state, action) => {
      state.homeContentError = action.payload;
      state.homeContentLoading = false;
    },
    // Platforms Contnet actions

    // Home content actions
    setPlatformsListLoading: (state, action) => {
      state.homePlatformsListLoading = action.payload;
      if (action.payload) {
        state.homePlatformsListError = null;
      }
    },
    setPlatformsList: (state, action) => {
      state.homePlatformsList = action.payload;
      state.homePlatformsListLoading = false;
      state.homePlatformsListError = null;
      // if (!state.selectedPlatform) {
      //   const list = action.payload?.platformsList || [];
      //   const wfn = list.find(p => p.sorCode === 'WFN') || list[0];
      //   if (wfn) state.selectedPlatform = wfn;
      // } else if (state.selectedPlatform?.sorCode === 'WFN' && !state.selectedPlatform.displayName) {
      //   // enrich default with real object
      //   const wfn = (action.payload?.platformsList || []).find(p => p.sorCode === 'WFN');
      //   if (wfn) state.selectedPlatform = wfn;
      // }
    },
    setPlatformsListError: (state, action) => {
      state.homePlatformsListError = action.payload;
      state.homePlatformsListLoading = false;
    },

    // App state actions
    setCurrentApp: (state, action) => {
      state.currentApp = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setCountryAndLocale: (state, action) => {
      state.country = action.payload.country;
      state.locale = action.payload.locale;
    },
    setSelectedPlatform: (state, action) => {
      state.selectedPlatform = action.payload; // full object { sorCode, displayName, ... }
    },
    // (optional backward compatibility)
    setSelectedSorCode: (state, action) => {
      // deprecated: wrap into object if existing platform list has match
      state.selectedPlatform = { sorCode: action.payload };
    },
    setMobileSearchOpen: (state, action) => {
      state.isMobileSearchOpen = action.payload;
    }
  }
});
export const {
  setUser,
  setGaClientId,
  clearUser,
  setHomeContentLoading,
  setHomeContent,
  setHomeContentError,
  setCurrentApp,
  setLoading,
  setError,
  clearError,
  setActiveTab,
  setCountryAndLocale,
  setPlatformsListLoading,
  setPlatformsList,
  setPlatformsListError,
  setSelectedPlatform,
  setSelectedSorCode,
  setMobileSearchOpen
} = appSlice.actions;
export default appSlice.reducer;
